module.exports = __webpack_public_path__ + "public/img/fx.60073955.png";